import {Client} from '@stomp/stompjs';
import SockJS from 'sockjs-client';

function TrainManagementController(
  PackageService,
  $interval,
  $uibModal,
  $stateParams,
  MTService,
  toasterService,
  config,
  $state,
  __env
) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.currentTab = 'train-management';
    ctrl.uploadProgressList = [];
    ctrl.currentlyUpdatingProgressList = [];
    ctrl.filteredPackages = [];
    ctrl.consist = $stateParams.consist;
    ctrl.carFromUrl = $stateParams.carNumber;
    ctrl.trainCars = ctrl.topology.root.modules;
    const carObject = ctrl.trainCars.find(car => car.id === ctrl.carFromUrl);
    ctrl.selectCar(carObject);

    ctrl.fetchTrainUploadProgress();
    ctrl.fetchAvailablePackages();
    ctrl.startProgressPoll();
    ctrl.startAvailablePackagesPoll();
    initializeSocket();

    ctrl.updateModulesList();
    ctrl.hasProfile = env.profile === 'LU';
    ctrl.hasPackageActivation = env.profile !== 'VALE';
    ctrl.hasTopologyDownload = env.profile === 'LU' || env.profile === 'DEMO';
    ctrl.wideTrains = env.profile === 'VALE' || env.profile === 'DEMO';
    ctrl.hasHighSpeedTrain = env.profile !== 'LU';
    ctrl.hasOperatingMode = env.profile === 'LU' || env.profile === 'DEMO';
    ctrl.hasClockAndMode = env.profile !== 'VALE';
    ctrl.textFile = "";
  };

  const initializeSocket = async () => {
    const socketURL = config.socketURL;
    const client = new Client({
      webSocketFactory: () => new SockJS(socketURL + '/service/socket', null, {transports: ['websocket']}),
      onConnect: () => {
        console.info('Connected websocket ', socketURL + '/service/socket');
        client.subscribe('/topology/' + ctrl.consist + '/updated',
          message => {
            const consist = message.body;
            console.log('Train topology changed for consist', consist);
            receiveUpdateNotification();
          }
        );
      },
      onStompError: frame => {
        console.error('Stomp Socket error', frame.headers['message'], frame.body);
      }
    });
    client.activate();
    ctrl.client = client;
  };


  // Receives notification when updated information is available from the backend.
  const receiveUpdateNotification = () => {
    MTService.getTopology(ctrl.consist).then(data => {
      ctrl.topology = data;
      ctrl.updateModulesList();
    });
  };

  ctrl.updateModulesList = () => {
    if (angular.equals({}, ctrl.topology)) {
      ctrl.emptyTopology = true;
    }
    if (ctrl.descriptors.length === 0) {
      ctrl.noDescriptorData = true;
    }
    if (!ctrl.emptyTopology) {
      ctrl.processModulesVersionStatus();
      ctrl.fetchAvailablePackages();
      ctrl.loading = false;
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.progressStatusPromise);
    $interval.cancel(ctrl.availablePackagesPromise);
    ctrl.client.deactivate(); // Close the WebSocket connection
  };

  ctrl.startProgressPoll = () => {
    ctrl.lastProgressLoad = DateTime.now();
    ctrl.progressStatusPromise = $interval(ctrl.triggerUploadProgressLoad, 5000);
  };

  ctrl.startAvailablePackagesPoll = () => {
    ctrl.lastAvailableLoad = DateTime.now();
    ctrl.availablePackagesPromise = $interval(ctrl.triggerAvailablePackagesLoad, 10000);
  };

  ctrl.fetchTrainUploadProgress = () => {
    PackageService.getUploadProgressList(ctrl.consist).then(data => {
      ctrl.currentlyUpdatingProgressList = [];
      ctrl.uploadProgressList = data;
      ctrl.uploadProgressList.forEach(item => {
        if (item.phase.toUpperCase() === "DOWNLOADING" ||
          item.phase.toUpperCase() === "INITIALIZED" ||
          item.phase.toUpperCase() === "IN_PROGRESS"
        ) {
          ctrl.currentlyUpdatingProgressList.push(item);
        }
      });
      ctrl.lastProgressLoad = DateTime.now();
    });
  };

  ctrl.fetchAvailablePackages = () => {
    PackageService.getAvailablePackages(ctrl.consist)
      .then(data => {
        ctrl.availablePackages = data;
        if (ctrl.availablePackages.length) {
          ctrl.availablePackages.forEach(pkg => {
            // Check if the package is in every car of the train
            // where module of the same type is present.
            if (!ctrl.processPackage(pkg)) return;
            // Only add packages to the list with valid version descriptor.
            if (!(pkg.status === 'Sanctioned' || pkg.status === 'Engineering' || pkg.status === 'Valid')) return;

            let packageAlreadyAdded = false;
            ctrl.filteredPackages.forEach(filteredPackage => {
              if (filteredPackage.filename === pkg.filename) {
                packageAlreadyAdded = true;
              }
            });
            if (!packageAlreadyAdded) {
              ctrl.filteredPackages.push(pkg);
            }
          });
        }
        ctrl.lastAvailableLoad = DateTime.now();
      })
      .catch(error => {
        console.log('Error: ' + error);
        ctrl.lastAvailableLoad = DateTime.now();
      });
  };

  ctrl.processInnerModulesLists = (module, car) => {
    if (module.modules && module.modules.length > 0) {
      module.modules.map(submodule => {
        ctrl.processVersionStatus(submodule, car);
        ctrl.processInnerModulesLists(submodule, car);
      });
    }
  };

  ctrl.processModulesVersionStatus = () => {
    if (!ctrl.trainCars || ctrl.trainCars.length === 0) return;
    ctrl.trainCars.forEach(car => {
      car.versionNotification = false;
      car.moduleHealthNotification = false;
      if (car.modules && car.modules.length > 0) {
        car.modules.forEach(group => {
          ctrl.processInnerModulesLists(group, car);
        });
      }
      if (!car.modules || car.modules.length === 0) {
        car.moduleHealthNotification = true;
      }
    });
  };

  ctrl.selectCar = value => {
    ctrl.activeObject = value;
    ctrl.selectedCar = value;
    $state.go('train.management', {carNumber: ctrl.selectedCar.id, trainId: ctrl.consist}, {notify: false});
  };

  ctrl.selectModule = event => {
    ctrl.activeObject = event;
  };

  ctrl.uploadStart = () => {
    ctrl.fetchTrainUploadProgress();
  };

  ctrl.processVersionStatus = (item, car) => {
    item.hw_upgrade_available = {
      version_number: null,
      date_created: null,
    };
    item.sw_upgrade_available = [];

    // Display alarm indicator if module health status is 0 (broken)
    if (item.status === 0) {
      car.moduleHealthNotification = true;
    }

    const matchingModule = ctrl.descriptors.find(module => module.type === item.module_family_name);
    if (!matchingModule) {
      // Some modules don't have versions at all
      if (item.software_version || item.hardware_version) {
        // Module not found --> Version descriptor does not exist --> Version: Unknown
        item.hardware_version_status = 'Unknown';
        item.software_version_status = 'Unknown';
        car.versionNotification = true;
      }
      return;
    }

    const matchingHwRev = matchingModule.hw_revision.findLast(hwDescriptor => hwDescriptor.version_number === item.hardware_version);
    if (matchingHwRev) {
      item.hardware_version_status = matchingHwRev.status;
      item.hardware_version_date_created = matchingHwRev.date_created;
    } else {
      // Hardware not found --> Version descriptor does not exist --> Version: Unknown
      item.hardware_version_status = 'Unknown';
      item.hardware_version_date_created = null;
      // car.versionNotification not set for hardware versions
    }

    const hwUpgrade = matchingModule.hw_revision.findLast(hwDescriptor => hwDescriptor.status === 'Sanctioned' || hwDescriptor.status === 'Engineering');
    if (hwUpgrade) {
      item.hw_upgrade_available.version_number = hwUpgrade.version_number;
      item.hw_upgrade_available.date_created = hwUpgrade.date_created;
    }

    const matchingSwRev = matchingModule.sw_revision.findLast(swDescriptor => swDescriptor.version_number === item.software_version);
    if (matchingSwRev) {
      item.software_version_status = matchingSwRev.status;
      item.software_version_date_created = matchingSwRev.date_created;
    } else {
      // Software not found --> Version descriptor does not exist --> Version: Unknown
      item.software_version_status = 'Unknown';
      item.software_version_date_created = null;
      car.versionNotification = true;
    }

    const availablePackages = matchingModule.sw_revision
      .filter(swDescriptor => swDescriptor.status === 'Sanctioned' ||
        swDescriptor.status === 'Engineering' ||
        swDescriptor.status === 'Valid');
    item.sw_upgrade_available.push(...availablePackages.map(swDescriptor => {
      return {
        version_number: swDescriptor.version_number,
        date_created: swDescriptor.date_created,
        descriptor: swDescriptor.status,
      };
    }));
    item.packages_available = item.sw_upgrade_available;
  };

  ctrl.triggerUploadProgressLoad = () => {
    if (ctrl.lastProgressLoad.diffNow('seconds').seconds < -5) {
      ctrl.fetchTrainUploadProgress();
    }
  };

  ctrl.triggerAvailablePackagesLoad = () => {
    if (ctrl.lastAvailableLoad.diffNow('seconds').seconds < -10) {
      ctrl.fetchAvailablePackages();
    }
  };

  ctrl.checkPackageAvailability = packageType => {
    let carsWithModule = [];
    for (const car of ctrl.trainCars) {
      if (car.modules && car.modules.length > 0) {
        for (const group of car.modules) {
          if (group.modules && group.modules.find(module => module.module_family_name === packageType)) {
            carsWithModule.push(car.car_number);
          }
        }
      }
    }
    return carsWithModule;
  };

  ctrl.processPackage = pkg => {
    // Returns a list of car numbers with the module type (e.g. 'RIM')
    let carsWithModule = ctrl.checkPackageAvailability(pkg.moduleType);
    let carsWithPackage = [];
    let filteredPackages = ctrl.availablePackages.filter(obj => obj.moduleType === pkg.moduleType);
    carsWithModule.forEach(car => {
      filteredPackages.forEach(pkg => {
        if (car === parseInt(pkg.source)) {
          carsWithPackage.push(car);
        }
      });
    });
    if (angular.equals(carsWithModule, carsWithPackage)) {
      // Package is in every car
      return true;
    } else {
      // Package IS NOT in every car
      return false;
    }
  };

  const getWhiteSpaceString = (depth) => {
    let spaceString = ""; 
    if (depth === 1) {
      spaceString = '\t';
    }
    if (depth > 1) {
      for (let i = 0; i < depth; i++) {
         spaceString = spaceString.concat('\t');
      }
    }
    return spaceString;
  }

  const printModules = (modulesArray, depthIndex) => {
    const depth = ++depthIndex;
    const titleSpace = getWhiteSpaceString(depth);
    // Add two spaces before the actual content inside a main level
    const contentSpace = titleSpace.concat('  ');
    modulesArray.forEach(module => {
      if (depth === 1) {
        // This is the module category level, such as DTS, PIS, TRAINBORNE
        const numOfModules = module.modules ? module.modules.length : 0;
        if (numOfModules) {
          ctrl.textFile = ctrl.textFile.concat(titleSpace).concat(module.display_name).concat('\r\n');
        }
      }
      else if (depth > 1) {
        ctrl.textFile = ctrl.textFile.concat(titleSpace).concat(module.display_name).concat('\r\n');;

        const softwareVersion = module.software_version ? module.software_version : "N/A";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Software version: ").concat(softwareVersion).concat('\r\n');
 
        const softwareVersionStatus = module.software_version_status ? module.software_version_status : "N/A";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Descriptor: ").concat(softwareVersionStatus).concat('\r\n');

        const serialNumber = module.serial_number ? module.serial_number : "N/A";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Serial Number: ").concat(serialNumber).concat('\r\n');

        const location = module.location ? module.location : "N/A";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Location: ").concat(location).concat('\r\n');
 
        const macAddress = module.mac_address ? module.mac_address : "N/A";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Mac address: ").concat(macAddress).concat('\r\n');

        const healthStatus = module.status ? "OK" : "Not OK";
        ctrl.textFile = ctrl.textFile.concat(contentSpace).concat("Status: ").concat(healthStatus).concat('\r\n');
      }
      if (module.modules) {
        printModules(module.modules, depth);
      }
    });
  }

  ctrl.exportTopology = () => {
    const trainName = ctrl.consist;
    const fileDate = DateTime.now().toFormat('yyyy-MM-dd HHmmss');
   
    ctrl.trainCars = ctrl.topology.root.modules;
    ctrl.trainCars.forEach(car => {
      ctrl.textFile = ctrl.textFile.concat("Car: ").concat(car.car_number).concat('\r\n');
      printModules(car.modules, 0);
    });
    if (ctrl.textFile) {
      const link = document.createElement('a');
      link.download = trainName.concat(' ').concat(fileDate).concat(' topology.txt');
      var blob = new Blob([ctrl.textFile], {type: 'text/plain'});
      link.href = window.URL.createObjectURL(blob);
      link.click();
    }

    // Exporting the original topology json as well
    const topologyJSON = JSON.stringify({'root': ctrl.topology.root});
    const link = document.createElement('a');
    link.download =  trainName.concat(' ').concat(fileDate).concat(' topology.json');
    const data = 'text/json;charset=utf-8,' + encodeURIComponent(topologyJSON);
    link.href = 'data:' + data;
    link.click();

    toasterService.success('Topology exported', 'Check the downloads folder');
  };

  ctrl.openActivationModal = () => {
    let modalInstance = $uibModal.open({
      component: 'softwareActivationModal',
      resolve: {
        packages: function () {
          return ctrl.filteredPackages;
        },
        train: function () {
          return ctrl.train;
        },
        carNumber: function () {
          return ctrl.carNumber;
        },
        descriptors: function () {
          return ctrl.descriptors;
        },
        mode: function () {
          return 'train';
        },
      },
    });

    modalInstance.result.then(
      () => {
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('configuration-management.module')
  .controller('TrainManagementController', TrainManagementController);
